<h2 class="c-card__title" mat-dialog-title>{{ 'CATEGORIES.ACTUALITES.CHOISIR.IMAGE' | translate }}</h2>
<mat-dialog-content class="mat-typography">
    <h4>
        {{ 'CATEGORIES.ACTUALITES.UPLOAD_IMAGE.TAILLE' | translate: {width, height, weight: maxSize / 1000000} }}
    </h4>
    <div *ngIf="loading">
        <mat-spinner></mat-spinner>
    </div>
    <div>
        <form [formGroup]="form">
            <div class="form-group c-card__download">
                <div class="mt-5 mb-3 mb-lg-0 mx-4 input-container">
                    <label for="fileToImport" class="custom-file-label">
                        {{ 'CATEGORIES.ACTUALITES.CHOISIR.FICHIER' | translate }}
                    </label>
                    <input (change)="fileChangeEvent($event)" [writeFile]="true" formControlName="fileToImport" type="file" id="fileToImport" class=" ml-lg-4" hidden>
                    <span>{{ (!imageChangedEvent) ? ('CATEGORIES.ACTUALITES.AUCUN_FICHIER_CHOISI' | translate) : imageChangedEvent.srcElement.files[0].name }}</span>
                </div>
                <div *ngIf="errorImage" class="c-asterisk"> test
                    * La taille minimum attendue pour l'image est de {{ width }}x{{ height }} px.
                </div>
            </div>
        </form>
        <div class="row">
            <div class="col-5">
                <img [src]="croppedImage" [style.border]="croppedImage ? '1px solid black' : 'none'"/>
            </div>
            <div class="col-7">
                <image-cropper (imageCropped)="imageCropped($event)" [aspectRatio]="width/height"
                               [containWithinAspectRatio]="false"
                               [cropperMinHeight]="height" [cropperMinWidth]="width" [cropper]="cropper"
                               [imageChangedEvent]="imageChangedEvent"
                               [resizeToHeight]="height"
                               [resizeToWidth]="width"></image-cropper>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="c-create-news__btn justify-content-between mt-md-2 mt-lg-3">
    <button (click)="closeImageDialog()" [disabled]="this.uploading" class="c-btn c-btn--blue mb-3  {{this.uploading ? 'disabled' : null}}" mat-dialog-close>
        {{ 'UTILS.FERMER' | translate }}
    </button>
    <button (click)="uploadImage()" [disabled]="this.uploading || !croppedImage" cdkFocusInitial class="c-btn c-create-news__btn--next mb-3 ml-lg-4 {{this.uploading || !croppedImage ? 'disabled' : null}}" type="button">
        {{ 'UTILS.SAUVEGARDER' | translate }}
        <span class="spinner-wrapper">
            <mat-progress-spinner *ngIf="this.uploading" [diameter]="14" mode="indeterminate">
            </mat-progress-spinner>
        </span>

    </button>
</mat-dialog-actions>
